var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthenticateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_220_467)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_220_467)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 64,
    height: 64,
    rx: 18,
    fill: "url(#paint0_linear_220_467)",
    fillOpacity: 0.3,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 64,
    height: 64,
    rx: 18,
    fill: "url(#paint1_linear_220_467)",
    fillOpacity: 0.3,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 64,
    height: 64,
    rx: 18,
    fill: "url(#paint2_radial_220_467)",
    fillOpacity: 0.1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bdi_220_467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0177 39.3888C29.9865 38.1994 29.9709 37.6047 30.2 36.9842C30.397 36.4509 30.7524 35.9391 31.1834 35.5684C31.6848 35.137 32.4059 34.8897 33.8481 34.395C37.5044 33.1408 41.0259 31.4096 44.3292 29.3846C45.5992 28.6061 46.2341 28.2169 46.7929 28.092C47.3414 27.9693 47.7454 27.9693 48.2939 28.092C48.8527 28.2169 49.4877 28.6061 50.7576 29.3846C54.0609 31.4096 57.5824 33.1408 61.2387 34.395C62.6809 34.8897 63.402 35.137 63.9034 35.5684C64.3344 35.9391 64.6899 36.4509 64.8868 36.9842C65.1159 37.6047 65.1003 38.1994 65.0691 39.3888C64.972 43.0907 64.3554 48.8454 61.8314 54.0192C58.5581 60.7289 53.0406 65.0767 49.9061 67.1418C49.2544 67.5712 48.9285 67.7859 48.3376 67.9261C47.9226 68.0246 47.1642 68.0246 46.7492 67.9261C46.1584 67.7859 45.8325 67.5712 45.1807 67.1418C42.0462 65.0767 36.5287 60.7289 33.2555 54.0192C30.7315 48.8454 30.1148 43.0907 30.0177 39.3888Z",
    fill: "white",
    fillOpacity: 0.3,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bdi_220_467)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.534 51.1548L55.1674 40.5215L57.5446 42.8987L44.534 55.9093L37.9436 49.3188L40.3208 46.9416L44.534 51.1548Z",
    fill: "white",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 16.5,
    width: 63,
    height: 63,
    rx: 17.5,
    stroke: "white",
    strokeOpacity: 0.05,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_220_467",
    x: 0,
    y: 0,
    width: 96,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.172549 0 0 0 0 0.054902 0 0 0 0 0.529412 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_220_467"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_220_467",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bdi_220_467",
    x: 10,
    y: 18,
    width: 75.0869,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_220_467"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_220_467",
    result: "effect2_dropShadow_220_467"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_220_467",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_220_467"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bdi_220_467",
    x: 17.9436,
    y: 30.5215,
    width: 59.6011,
    height: 55.3877,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_220_467"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_220_467",
    result: "effect2_dropShadow_220_467"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_220_467",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_220_467"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_220_467",
    x1: 33.5,
    y1: 57.5,
    x2: 19,
    y2: 73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6238DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#351E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_220_467",
    x1: 61,
    y1: 48,
    x2: 80,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6238DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#351E77"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_220_467",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.5 60.5) rotate(-139.399) scale(59.927)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_220_467"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 64,
    height: 64,
    rx: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthenticateIcon);
export default __webpack_public_path__ + "static/media/authenticate_icon.4b77e68a8f1deb0c9e6204baf763ad9f.svg";
export { ForwardRef as ReactComponent };